module.exports = "pegasus/assets/circle-youtube.gif";